import { ButtonIcon, Callout, EllipsisHIcon, Tooltip } from 'canoe';
import React, { useRef, useState } from 'react';

import { MenuBody } from 'craft/components/ContextMenu/MenuBody';
import { useViewportDom } from 'craft/state/viewport/selectors';

export const ContextMenuButton = () => {
  const ref = useRef<HTMLButtonElement>(null);
  const [isToolbarVisible, setToolbarVisible] = useState(false);
  const { viewportWrapperEl } = useViewportDom();

  return (
    <>
      {isToolbarVisible && (
        <Callout
          usePortal={false}
          referenceElement={ref.current}
          onClose={() => setToolbarVisible(false)}
          closeKey="Escape"
          placement="bottom-end"
          modifiers={[
            {
              name: 'preventOverflow',
              options: {
                boundary: viewportWrapperEl,
                padding: 8,
              },
            },
          ]}
        >
          {(calloutProps) => (
            <div
              data-craft-ignore-events
              ref={calloutProps.ref}
              style={calloutProps.style}
              {...calloutProps.attributes.popper}
            >
              <MenuBody />
            </div>
          )}
        </Callout>
      )}
      <Tooltip placement="top" offset="xxs" content="Context Menu">
        <ButtonIcon
          ref={ref}
          size="small"
          onClick={() => {
            window.requestAnimationFrame(() => setToolbarVisible(!isToolbarVisible));
          }}
          icon={EllipsisHIcon}
          radius="small"
          color="white"
        />
      </Tooltip>
    </>
  );
};
